module.exports = __webpack_public_path__ + "mrstaticmedia/3-1@2x.9e4899b3.png";